(function () {
  if (window.JuzooriHeaderMenu) return;
  window.JuzooriHeaderMenu = true;

  function patchMenuDisclosure(Ctor) {
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__juzooriHeaderMenu) return;

    var proto = Ctor.prototype;
    proto.__juzooriHeaderMenu = true;

    var originalOpen = proto.open;
    var originalClose = proto.close;

    Object.defineProperty(proto, "mouseOverDelayTolerance", {
      configurable: true,
      get: function () {
        return 350;
      }
    });

    proto.open = async function (opts) {
      var details = this.disclosureElement;
      this.__juzooriMenuGen = (this.__juzooriMenuGen || 0) + 1;

      if (details && details.getAttribute("aria-expanded") === "true" && !details.open) {
        details.setAttribute("aria-expanded", "false");
      }

      if (this.contentElement) {
        this.contentElement.style.removeProperty("opacity");
      }

      return originalOpen.call(this, opts);
    };

    proto.close = async function () {
      var details = this.disclosureElement;
      if (!details) return originalClose.call(this);

      if (!details.__juzooriNativeRemove) {
        var host = this;
        details.__juzooriNativeRemove = details.removeAttribute.bind(details);
        details.removeAttribute = function (name) {
          if (name === "open") {
            if (details.getAttribute("aria-expanded") === "true") return;
            if (details.__juzooriCloseGen !== host.__juzooriMenuGen) return;
          }
          return details.__juzooriNativeRemove(name);
        };
      }

      details.__juzooriCloseGen = this.__juzooriMenuGen || 0;
      return originalClose.call(this);
    };
  }

  function init() {
    patchMenuDisclosure(window.customElements.get("mega-menu-disclosure"));
    patchMenuDisclosure(window.customElements.get("dropdown-menu-disclosure"));
  }

  if (window.customElements.get("mega-menu-disclosure")) {
    init();
  } else {
    window.customElements.whenDefined("mega-menu-disclosure").then(init);
  }

  document.addEventListener("shopify:section:load", init);
})();
